// Generated from App.tsx for a single page build. Do not edit.
// Generated by the server from the registered pages. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import ProjectGalleryPage from "../pages/ProjectGallery/ProjectGallery";
const __wvcRoutePaths = ["/ProjectGalleryPage", "/project-gallery"];
function AppRoutes() {
  const location = useLocation();
  const owned = new Set(["book-appointment", "bookappointmentpage", "home", "homepage", "manager-profile", "managerprofilepage", "post", "project-gallery", "projectgallerypage"]);
  const segment = (location.pathname.split('/')[1] || '').toLowerCase();
  return <Routes key={owned.has(segment) ? segment : '/'}>
      
      
      <Route path={__wvcRoutePaths[0]} element={<ProjectGalleryPage />} />
      
      
      
      
      
      <Route path={__wvcRoutePaths[1]} element={<ProjectGalleryPage />} />
      
      
    </Routes>;
}
function App() {
  return <>
      <AppRoutes />
    </>;
}
export default App;
